/* eslint-disable */

import { congressEndpoint } from './patterns/endpoints';
import { addOption, clearHtml, createCongressEl, resultCounter, returnToSearch, zeroResults } from './patterns/dynamic-html';
import { sortAsc, sortDesc } from './patterns/sort-util';
import { loadMore } from './patterns/load-more.utils';
import { toggleFilters } from './patterns/toggle-congress-filters';

const date = new Date();
const currentYear = date.getFullYear();
const nextYear = currentYear + 1;
const previousYear = currentYear - 1;
let pastCongressData = [];
let upcomingCongressData = [];

const handlePastCongressFilters = (e) => {
    const pastCongressWrapper = document.querySelector('.congress-wrapper--past');

    //Clear filter
    let filtersPast = {
        'name': '',
        'category': '',
        'year': '',
    };

    //Clear current results
    clearHtml(pastCongressWrapper);
    //Add loading icon back
    document.querySelector('.congresses.container').setAttribute('data-loading', 'true');

    //Create new filter
    filtersPast.name = document.getElementById('namePast').value;
    filtersPast.category = [...document.querySelectorAll('#categoryPast input[type="checkbox"]:checked')].reduce((acc, c) => {
        acc.push(c.value);
        return acc;
    }, []);
    filtersPast.year = document.getElementById('yearPast').value;
    filtersPast.asset = document.getElementById('assetsPast').value;

    const filteredPastCongressData = pastCongressData.filter(a => {
        return filtersPast.name === 'All Congress Names' ? a.name === a.name : a.name === filtersPast.name;
    }).filter(b => {
        return filtersPast.category.some(cat => b.allCategories.includes(cat));
    }).filter(c => {
        if (filtersPast.year === 'All Available') {
            return c.year === c.year
        }
        else if(filtersPast.year === 'Current Year') {
            return c.year === currentYear;
        }
        else if(filtersPast.year === 'Previous Year') {
            return c.year === previousYear;
        }
        else if(filtersPast.year === 'Last 60 Days') {
            return c.days >= -60 && c.days <= 0;
        }
    }).filter(d => {
        return filtersPast.asset === 'All Poster and Presentation Names' ? d.allAssets === d.allAssets : d.allAssets.includes(filtersPast.asset);
    });
       //Checkbox dropdown button handling
       if (e.target.closest('#categoryPast')) {
        const checkboxButton = document.getElementById('categoryPast-button');
        const allCheckboxes = document.querySelectorAll('#categoryPast input[type="checkbox"]');
        const checkedCount = filtersPast.category.length;

        if(checkedCount === 0) {
            checkboxButton.querySelector('span').innerHTML = 'Select Category';
            checkboxButton.setAttribute('aria-label', 'Select Category');
        } else if(checkedCount === allCheckboxes.length) {
            checkboxButton.querySelector('span').innerHTML = 'All Categories';
            checkboxButton.removeAttribute('aria-label');
        } else {
            checkboxButton.querySelector('span').innerHTML = filtersPast.category.join(', ');
            checkboxButton.removeAttribute('aria-label');
        }
    }

    //Remove loading icon
    document.querySelector('.congresses.container').setAttribute('data-loading', 'false');

    //Show message if there are no results
    zeroResults(filteredPastCongressData, '.congress__zero-results--past', '.congress__return-to-search--past');

    //Pupulater new results
    filteredPastCongressData.map((c, index) => {
        pastCongressWrapper.appendChild(createCongressEl(c, index));
    });

    //Populate results counter past
    resultCounter(filteredPastCongressData, '.congress__counter--past span');

    //Handle load more after filtering
    if(document.querySelectorAll('.congress--past[hidden]').length > 0) {
        document.querySelector('.load-more--past').hidden = false;
    } else {
        document.querySelector('.load-more--past').hidden = true;
    }

    //Add modal handler
    if(document.querySelectorAll('.congress__website a').length > 0) {
        document.querySelectorAll('.congress__website a').forEach(a => {
            a.addEventListener('click', e => {
                e.preventDefault();
                const targetUrl = e.target.href;
                document.querySelector('#exit-modal a.modal__continue').href = targetUrl;
            });
        });
    }
}

const handleUpcomingCongressFilters = (e) => {
    const upcomingCongressWrapper = document.querySelector('.congress-wrapper--upcoming');

    //Clear filter
    let filtersUpcoming = {
        'name': '',
        'year': '',
    };

    //Clear current results
    clearHtml(upcomingCongressWrapper);
    //Add loading icon back
    document.querySelector('.congresses.container').setAttribute('data-loading', 'true');

    //Create new filter
    filtersUpcoming.name = document.getElementById('nameUpcoming').value;
    filtersUpcoming.year = document.getElementById('yearUpcoming').value;

    const filteredUpcomingCongressData = upcomingCongressData.filter(a => {
        return filtersUpcoming.name === 'All Congress Names' ? a.name === a.name : a.name === filtersUpcoming.name;
    }).filter(c => {
        if (filtersUpcoming.year === 'All Available') {
            return c.year === c.year
        }
        else if(filtersUpcoming.year === 'Current Year') {
            return c.year === currentYear;
        }
        else if(filtersUpcoming.year === 'Next Year') {
            return c.year === nextYear;
        }
        else if(filtersUpcoming.year === 'Next 60 Days') {
            return c.days >= 0 && c.days <= 60;
        }
    })

    //Remove loading icon
    document.querySelector('.congresses.container').setAttribute('data-loading', 'false');
    //Show message if there are no results
    zeroResults(filteredUpcomingCongressData, '.congress__zero-results--upcoming', '.congress__return-to-search--upcoming');

    //Pupulater new results
    filteredUpcomingCongressData.map((c, index) => {
        upcomingCongressWrapper.appendChild(createCongressEl(c, index));
    });

    //Populate results counter upcoming
    resultCounter(filteredUpcomingCongressData, '.congress__counter--upcoming span');

    //Handle load more after filtering
    if(document.querySelectorAll('.congress--upcoming[hidden]').length > 0) {
        document.querySelector('.load-more--upcoming').hidden = false;
    } else {
        document.querySelector('.load-more--upcoming').hidden = true;
    }

    //Add modal handler
    if(document.querySelectorAll('.congress__website a').length > 0) {
        document.querySelectorAll('.congress__website a').forEach(a => {
            a.addEventListener('click', e => {
                e.preventDefault();
                const targetUrl = e.target.href;
                document.querySelector('#exit-modal a.modal__continue').href = targetUrl;
            });
        });
    }
}

window.addEventListener('load', () => {
    if(document.querySelector('.congresses--past') || document.querySelector('.congress--upcoming')) {
        //Handle <strong>Return to search</strong> past/upcoming
        returnToSearch('.congress__return-to-search--past', '.search-label--congress-past');
        returnToSearch('.congress__return-to-search--upcoming', '.search-label--congress-upcoming');

        //Fetch data
        fetch(congressEndpoint)
        .then(response => response.json())
        .then(data => {

            if(data.success !== true) {
                document.querySelectorAll('.congresses .processing-error.error').forEach(e => {
                    e.classList.add('show');
                });
            }
            else {
                const pastCongressWrapper = document.querySelector('.congress-wrapper--past');
                const upcomingCongressWrapper = document.querySelector('.congress-wrapper--upcoming');
                const congressData = data.data.congress;

                // Populate congress names dropdowns
                const pastCongressUnique = [...new Set(congressData.filter(c => { return c.timeframe === 'past'; }).map(c => c.name))].map(c => ({name: c}));
                const upcomingCongressUnique = [...new Set(congressData.filter(c => { return c.timeframe === 'upcoming'; }).map(c => c.name))].map(c => ({name: c}));
                addOption('namePast', sortAsc(pastCongressUnique, 'name'), 'name');
                addOption('nameUpcoming', sortAsc(upcomingCongressUnique, 'name'), 'name');

                // Populate ASSETS dropwdown in past congresses tab
                const allAssets = congressData.reduce((acc, congress) => {
                    //All asset titles array to data for filtering later
                    congress.allAssets = congress.assets ? congress.assets.map(a => a.title) : [];

                    // Add category to congress data
                    congress.allCategories = congress.assets ? congress.assets.map(a => a.category) : [];

                    if (congress.assets) {
                        acc.push(...congress.assets.map(a => ({title: a.title})));
                    }

                    return acc;
                }, [])

                const assetsData = sortAsc(allAssets, 'title');
                addOption('assetsPast', assetsData, 'title');
    
                //Remove loading icon
                document.querySelector('.congresses.container').setAttribute('data-loading', 'false');
    
                //Filter past/upcoming congresses
    
                pastCongressData = sortDesc(congressData.filter(c => {
                    return c.timeframe === 'past';
                }), 'startDate');
    
                upcomingCongressData = sortAsc(congressData.filter(c => {
                    return c.timeframe === 'upcoming';
                }), 'startDate');

                //Populate past/upcoming congresses
    
                pastCongressData.map((c, index) => {
                    pastCongressWrapper.appendChild(createCongressEl(c, index));
                });
    
                upcomingCongressData.map((c, index) => {
                    upcomingCongressWrapper.appendChild(createCongressEl(c, index));
                });

                //Show controls
                document.querySelectorAll('.congress-publication-bottom-controls[hidden]').forEach(c => {
                    c.hidden = false;
                })
    
                //Populate results counter past/upcoming
                resultCounter(pastCongressData, '.congress__counter--past span');
                resultCounter(upcomingCongressData, '.congress__counter--upcoming span');
    
                //Handle load more for past/upcoming congresses
                loadMore('.congress--past[hidden]', 5, '.load-more--past');
                loadMore('.congress--upcoming[hidden]', 5, '.load-more--upcoming');
    
                //Handle more/less filters for past/upcoming congresses
                toggleFilters(document.querySelector('.filter-toggle.filter-toggle--past'), document.querySelectorAll('.filter--yearPast, .filter--assetsPast'));
                toggleFilters(document.querySelector('.filter-toggle.filter-toggle--upcoming'), document.querySelectorAll('.filter--yearUpcoming'));

                //Add modal handler
                if(document.querySelectorAll('.congress__website a').length > 0) {
                    document.querySelectorAll('.congress__website a').forEach(a => {
                        a.addEventListener('click', e => {
                            e.preventDefault();
                            const targetUrl = e.target.href;
                            document.querySelector('#exit-modal a.modal__continue').href = targetUrl;
                        });
                    });
                }
    
                //Filter data using dropdowns
    
                //Past congresses
                document.querySelectorAll('.congresses select[data-timeframe="past"], .congresses input[type="checkbox"][data-timeframe="past"]').forEach(s => {
                    s.addEventListener('input', (e) => handlePastCongressFilters(e));
                });
    
                //Upcoming congresses
                document.querySelectorAll('.congresses select[data-timeframe="upcoming"]').forEach(s => {
                    s.addEventListener('input', (e) => handleUpcomingCongressFilters(e));
                })
            }
        })
    }
})

export {
    handlePastCongressFilters,
    handleUpcomingCongressFilters,
}
